import { PropertiesStore } from '@hortplus/properties-react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { ToastContainer } from '../../helpers/ToastUtils';
import SeasonOverviewReport from './SeasonOverviewReport';

const AdminSeasonOverviewReport = (props) => {
  return (
    <Fragment>
      <ToastContainer />
      <SeasonOverviewReport
        selectedDatabase={props.selectedDatabase}
        bearerToken={props.bearerToken}
        refreshBearerToken={props.refreshBearerToken}
        propertiesStore={props.propertiesStore}
        propertyId={props.propertyId}
      />
    </Fragment>
  );
};

AdminSeasonOverviewReport.propTypes = {
  selectedDatabase: PropTypes.string,
  bearerToken: PropTypes.string.isRequired,
  propertiesStore: PropTypes.instanceOf(PropertiesStore).isRequired,
  propertyId: PropTypes.number
};

export default observer(AdminSeasonOverviewReport);
